import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';
import classnames from 'classnames';
import { useAppSelector } from '../store/redux-hooks';
import { Checkbox } from '@mui/material';
import { CheckedType, SelectOptionType } from '../utils/Types';
import { trackLocationSelector } from '../features/trackLocationSlice';
import { isValidString } from '../utils/Util';
import { ROLE_IN_POPUP } from '../utils/RBAC';

interface IRoleModal {
  isOpen: boolean;
  toggle: () => void;
  previousRoles: string | undefined;
  className?: string;
  backdrop?: boolean | 'static';
  updateRole: (roles: SelectOptionType[]) => void;
}
const RoleModal: React.FunctionComponent<IRoleModal> = ({
  isOpen,
  toggle,
  className,
  backdrop,
  updateRole,
  previousRoles,
}) => {
  const roles = useAppSelector(trackLocationSelector).roleOptions;
  const [roleOptions, setRoleOptions] = useState<SelectOptionType[]>([]);
  const [selectedRoles, setSelectedRoles] = useState<SelectOptionType[]>([]);
  const [disabledApprove, setDisabledApprove] = useState<boolean>(true);
  const [selectedRolesChecked, setSelectedRolesChecked] = useState<CheckedType>(
    {}
  );
  const isObjectAvailable = (
    array: SelectOptionType[],
    value: string | number
  ) => {
    for (let index = 0; index < array.length; index++) {
      if (
        String(array[index].value) === String(value) ||
        Number(array[index].value) === Number(value)
      ) {
        return { isAvailable: true, index };
      }
    }
    return { isAvailable: false, index: -1 };
  };

  const onRoleChecked = (role: SelectOptionType) => {
    const value = Number(role.value);
    const rolesArray = [...selectedRoles];
    const available = isObjectAvailable(rolesArray, value);
    if (available.isAvailable) {
      rolesArray.splice(available.index, 1);
      const checkObj = { ...selectedRolesChecked };
      checkObj[String(value)] = false;
      setSelectedRolesChecked(checkObj);
    } else {
      rolesArray.push(role);
      const checkObj = { ...selectedRolesChecked };
      checkObj[String(value)] = true;
      setSelectedRolesChecked(checkObj);
    }
    setSelectedRoles(rolesArray);
  };
  const updateDefaultSelection = () => {
    if (previousRoles && roleOptions) {
      const rolesArray: SelectOptionType[] = [];
      const checkObj: CheckedType = {};
      for (const element of roleOptions) {
        if (previousRoles.includes(String(element.label))) {
          rolesArray.push(element);
          checkObj[String(element.value)] = true;
        } else {
          checkObj[String(element.value)] = false;
        }
      }
      setSelectedRoles(rolesArray);
      setSelectedRolesChecked(checkObj);
    }
  };
  const checkSelectedRoles = () => {
    let disabled = true;
    for (const element of selectedRoles) {
      if (!previousRoles?.includes(String(element.label))) {
        disabled = false;
        break;
      }
    }
    if (
      (isValidString(previousRoles) &&
        previousRoles?.split(',').length !== selectedRoles.length) ||
      (!isValidString(previousRoles) && selectedRoles.length > 0)
    ) {
      disabled = false;
    }
    setDisabledApprove(disabled);
  };
  useEffect(() => {
    checkSelectedRoles();
  }, [selectedRoles]);
  useEffect(() => {
    updateDefaultSelection();
  }, [roleOptions]);
  useEffect(() => {
    const roleOptions = roles?.filter((item: SelectOptionType) =>
      ROLE_IN_POPUP.includes(Number(item.value))
    );
    setRoleOptions(roleOptions);
  }, [roles]);
  return (
    <div className="role-modal-wrapper">
      <Modal
        isOpen={isOpen}
        backdrop={backdrop || 'static'}
        toggle={toggle}
        centered
        size="sm"
        className={classnames('modalProperties', className)}
      >
        <ModalBody>
          <div className="role-modal-wrapper">
            {roleOptions?.map((role: SelectOptionType, index: number) => (
              <div key={`div-checkbox-${String(index)}`}>
                <div className="d-flex justify-content-between align-items-center">
                  <span>{role.label}</span>
                  <Checkbox
                    key={`key-checkbox-${String(index)}`}
                    id={`id-checkbox-${String(index)}`}
                    className="role-check"
                    checked={
                      !!selectedRolesChecked[
                        String(role.value) as keyof CheckedType
                      ]
                    }
                    onChange={() => {
                      onRoleChecked(role);
                    }}
                  />
                </div>
                <hr className="mb-2 mt-2" />
              </div>
            ))}

            <div className="d-flex">
              <Button
                variant="primary"
                className="me-1 cl-btn-primary w-50"
                disabled={disabledApprove}
                onClick={() => {
                  updateRole(selectedRoles);
                }}
              >
                Update
              </Button>
              <Button
                variant="outline-primary"
                className="ms-1 cl-btn-outline-primary w-50"
                onClick={toggle}
              >
                Cancel
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default RoleModal;
